import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Radio,
  RadioGroup,
  Autocomplete,
  Box,
  Chip,
  Popper,
  Typography
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import './SPForm.scss';
import AppDatePicker from '../../AppFilterDate/AppDatePicker/AppDatePicker';
import { format } from 'date-fns';
import { validateInput } from '../../../pages/util/validateFormInput';
import GetLabels from '../../../pages/SellerProfile/GetLabels';
import {
  populateFormFields,
  checkRequiredContent,
  checkParentRequiredChecked,
  updateParentContent,
  // getAllExistingEmails,
  updateNameKeys,
  isEmailExists,
  getAllUsersBasedOnEmail,
  checkEmailExistsInList
} from './formHelpers';
import useScrollPosition from '../../../hooks/useScrollPosition';
import { useTranslation } from 'react-i18next';
import { ArrowDropDown } from '@mui/icons-material';
import CloseIcon from '../../../assets/images/gettingstarted/cancel.svg';
import { useSelector, useDispatch } from 'react-redux';
import {
  setErrorMsg,
  setFormUpdates,
  setDisabledBttn
} from '../../../redux/slices/sellerProfileSlice';

function SPForm({ ...props }) {
  const formRef = useRef(null) as any;
  const initialRef = useRef(null) as any;
  const scrollPosition = useScrollPosition();
  const [inputTextPos, setInputTextPos] = useState<any>('');
  // const [inputTextOPos, setInputTextOPos] = useState<any>('');

  const dispatch = useDispatch();


  const {
    formLoading,
    spPageText,
    formUpdates,
    defaultCompData,
    disabledBttn,
    seller_id,
    users
  } = useSelector((state: any) => state.sellerProfile);
  const { notificationRecipients } = useSelector(
    (state: any) => state.sellerProfile
  );
  const [fieldsWithError, setFieldsWithError] = useState<string[]>([]);
  const [enteredExistingEmail, setEnteredExistingEmail] = useState<string[]>(
    []
  );

  const businessModelList = defaultCompData?.business_model || [];

  const selectedBizModels = formUpdates?.editCompanyProfile?.impDetailsGroup?.options?.bizModelInfo?.options?.business_model_type?.content || [];
  // Compute if any selected business model requires IATA:
  const anyIataRequired = businessModelList?.some(
    (bm) => {
      const isSelected = selectedBizModels.includes(bm.business_model_type) ||
        selectedBizModels.includes(bm.business_model_type_fr);
      return isSelected && bm.iata_mandatory === 1;
    }
  );

  const { t, i18n } = useTranslation();
  const disableForm = props.disableForm ? props.disableForm === 1 : false;
  const [emailsList, setEmailsList] = useState<string[]>([]);
  const [emailExistsError, setEmailExistsError] = useState<boolean>(true);
  //util...  

  useEffect(() => {
    //clear out any old unsaved changes on load...
    let data = JSON.parse(JSON.stringify(formUpdates));
    data[props.formName] = {};

    dispatch(setFormUpdates({ ...formUpdates, [props.formName]: {} }));

    const doPrePopForm = populateFormFields(
      { ...props },
      i18n.language,
      props.formName
    );

    dispatch(
      setFormUpdates({
        ...formUpdates,
        [props.formName]: doPrePopForm.data
      })
    );
    setFieldsWithError(doPrePopForm.errors);
    dispatch(setErrorMsg(''));

    dispatch(
      setDisabledBttn({
        ...disabledBttn,
        [props.formName]: true
      })
    );
    const scrollRef = formRef.current ? formRef.current : initialRef.current;
    const formsToScrollFor = [
      'editUserProfile',
      'editNotifications',
      'editAPIcreds'
    ];
    if (formsToScrollFor.includes(props.formName)) {
      scrollRef.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest'
      });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.formFields]);

  useEffect(() => {
    if (
      props.formName === 'addNotificationRecip' ||
      props.formName === 'addUser'
    ) {
      let emailExistsAlready;

      if (emailsList?.length) {
        let email =
          props.formName === 'addUser'
            ? formUpdates[props.formName]['user_email']['content']
            : formUpdates[props.formName].inputFields.options['user_email'];

        emailsList?.forEach((e) => {
          if (e['label'] === email)
            emailExistsAlready = {
              user_first_name: e['user_first_name'],
              user_last_name: e['user_last_name'],
              user_email: e['user_email'],
              type:
                props.formName === 'addNotificationRecip'
                  ? 'userFromUserList'
                  : 'userFromNotifList'
            };
        });
      }

      if (emailExistsAlready) {
        let field = 'user_email';
        let getCurrErrors: string[] = [...fieldsWithError];
        const updateNameTypes = ['content'];
        const disableNameFields =
          emailExistsAlready?.type === 'userFromUserList' ? true : false;
        setEnteredExistingEmail([field]);
        disableNameFields && updateNameTypes.push('disable');

        updateNameKeys(
          field,
          formUpdates[props.formName],
          emailExistsAlready,
          updateNameTypes,
          getCurrErrors
        );
      }
    }
    // eslint-disable-next-line
  }, [emailsList]);

  useEffect(() => {
    if (
      props.formName === 'addNotificationRecip' ||
      props.formName === 'addUser'
    ) {
      if (formUpdates[props.formName]) {
        let field = 'user_email';
        let getCurrErrors: string[] = [...fieldsWithError];
        let curr =
          props.formName === 'addUser'
            ? formUpdates[props.formName][field]
            : formUpdates[props.formName]?.inputFields?.options[field];

        try {
          let emailExistsAlready;

          if (emailsList?.length) {
            let email =
              props.formName === 'addUser'
                ? formUpdates[props.formName]['user_email']['content']
                : formUpdates[props.formName].inputFields.options.user_email
                  .content;

            emailsList?.forEach((e) => {
              if (e['label'] === email)
                emailExistsAlready = {
                  user_first_name: e['user_first_name'],
                  user_last_name: e['user_last_name'],
                  user_email: e['user_email'],
                  type:
                    props.formName === 'addNotificationRecip'
                      ? 'userFromUserList'
                      : 'userFromNotifList'
                };
            });
          }

          if (emailExistsAlready) {
            let field = 'user_email';
            const updateNameTypes = ['content'];
            const disableNameFields =
              emailExistsAlready?.type === 'userFromUserList' ? true : false;
            setEnteredExistingEmail([field]);
            disableNameFields && updateNameTypes.push('disable');

            getCurrErrors = updateNameKeys(
              field,
              formUpdates[props.formName],
              emailExistsAlready,
              updateNameTypes,
              getCurrErrors
            );
          } else {
            if (
              props.formName === 'addNotificationRecip' ||
              props.formName === 'addUser'
            ) {
              curr.errorMsg =
                props.formName === 'addUser'
                  ? t('sellerProfile.dashboard.emailExists')
                  : t('sellerProfile.dashboard.notifEmailExists');
              curr.error = true;

              !getCurrErrors.includes(field) && getCurrErrors.push(field);
            } else {
              getCurrErrors = getCurrErrors.filter((f) => f !== field); //THIS SHOULD ONLY be removed from error list WHEN AUTO FILLING AS CONVENINCE, BUT not on Notif if exists on notif users already
            }
          }

          setFieldsWithError([...getCurrErrors]);
          dispatch(
            setFormUpdates({
              ...formUpdates,
              [props.formName]: formUpdates[props.formName]
            })
          );
          dispatch(
            setDisabledBttn({
              ...disabledBttn,
              [props.formName]: getCurrErrors.length > 0
            })
          );
        } catch (error) {
          console.log(error);
        }
      }
    }
    // eslint-disable-next-line
  }, [emailExistsError]);

  useEffect(() => {
    // Clear IATA validation errors when IATA is no longer required
    if (!anyIataRequired && props.formName === 'editCompanyProfile') {
      const localFormUpdates = JSON.parse(JSON.stringify(formUpdates));
      const iataField = localFormUpdates[props.formName]?.impDetailsGroup?.options?.bizModelInfo?.options?.iata_number;
      if (iataField && iataField.error) {
        iataField.error = false;
        iataField.errorMsg = '';
        const updatedErrors = fieldsWithError.filter((field) => field !== 'iata_number');
        setFieldsWithError(updatedErrors);
        // Update form data
        dispatch(setFormUpdates(localFormUpdates));
        // Update button disabled state
        dispatch(
          setDisabledBttn({
            ...disabledBttn,
            [props.formName]: updatedErrors.length > 0
          })
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [anyIataRequired, props.formName]);

  const [showHideSelect, setShowHideSelect] = useState([
    { key: false, value: '' }
  ]);

  const handleShowHideSelect = (label) => {
    const res = showHideSelect.map((v) => {
      if (v.value === label && v.key === true) {
        return {
          key: false,
          value: label
        };
      }
      if (v.value === label && v.key === false) {
        return {
          key: true,
          value: label
        };
      }
      if (v.value !== label) {
        return {
          key: true,
          value: label
        };
      } else {
        return v;
      }
    });
    setShowHideSelect(res);
  };

  useEffect(() => {
    if (scrollPosition) {
      setShowHideSelect([{ key: false, value: '' }]);
    }
  }, [scrollPosition]);

  const handleChange = async (
    e: any,
    curr,
    field,
    parentField,
    isAutoComplete = ''
  ) => {
    try {
      const localFormUpdates = JSON.parse(JSON.stringify(formUpdates));
      //Reset errors
      let getCurrErrors: string[] = [...fieldsWithError]; //use because state not updated immediately
      curr.errorMsg = '';
      curr.error = false;
      let update: string = '';

      if (curr.hasOwnProperty('checked') || curr['type'] === 'checkbox') {
        if (field === 'other_iata') {
          const newCheckedState = e.target?.checked;
          curr['checked'] = newCheckedState
          curr['content'] = newCheckedState;
        } else {
          curr['checked'] = !curr['checked'];
          curr['content'] = e.target?.checked;
        }

        if (curr?.type === 'radioOption') {
          localFormUpdates[props.formName][field].options[`option${curr?.id}`] =
            curr;
        } else {
          if (parentField === 'preferences') {
            localFormUpdates[props.formName]['userPreferences'].options[
              parentField
            ].options[field] = curr;
          }
          else {
            if (field === 'other_iata' && props.formName === 'editCompanyProfile') {
              localFormUpdates[props.formName].impDetailsGroup.options[parentField].options[field].content = curr;
            } else {
              localFormUpdates[props.formName][parentField].options[field] = curr;
            }
          }
        }
        if (curr.hasOwnProperty('parent')) {
          updateParentContent(curr.parent, localFormUpdates[props.formName]);
        }
      }
      // if (!(curr.hasOwnProperty('checked') || curr['type'] === 'checkbox')) {
        if (isAutoComplete === 'autocomplete') {
          update = e.target?.innerText || e.target?.value;
        } else {
          update = e.target?.value || e.target?.checked || '';
        }

        if (isAutoComplete === 'autoComplete') {
          update = e;
        }
        curr['content'] = update;
      // }

      let checkEmailExists, emailExistsAlready;

      if (
        field.includes('email') &&
        update.length > 0 &&
        (props.formName === 'addNotificationRecip' ||
          props.formName === 'addUser')
      ) {
        var flag;
        if (props.formName === 'addUser') flag = 'users';
        else if (props.formName === 'addNotificationRecip') flag = 'notifs';

        getAllUsersBasedOnEmail(update, flag, seller_id, setEmailsList);

        let validEmail = validateInput(curr, t);

        if (validEmail.error) {
          checkEmailExists = false;
        } else {
          emailExistsAlready = checkEmailExistsInList(
            update,
            users,
            notificationRecipients,
            props.formName === 'addNotificationRecip' ? 'notifs' : 'users'
          );

          if (emailExistsAlready) {
            checkEmailExists = emailExistsAlready;
          } else if (!emailExistsAlready && update.length > 0) {
            isEmailExists(
              update,
              seller_id,
              setEmailExistsError,
              emailExistsError
            );
            checkEmailExists = false;
          }
        }
      }

      if (checkEmailExists) {
        setEnteredExistingEmail([field]);
        const disableNameFields =
          emailExistsAlready?.type === 'userFromUserList' ? true : false;

        if (
          (props.formName === 'addNotificationRecip' &&
            !emailExistsAlready?.type) ||
          (props.formName === 'addUser' && !emailExistsAlready?.type)
        ) {
          curr.errorMsg =
            props.formName === 'addUser'
              ? t('sellerProfile.dashboard.emailExists')
              : t('sellerProfile.dashboard.notifEmailExists');
          curr.error = true;

          !getCurrErrors.includes(field) && getCurrErrors.push(field);
        } else {
          getCurrErrors = getCurrErrors.filter((f) => f !== field); //THIS SHOULD ONLY be removed from error list WHEN AUTO FILLING AS CONVENINCE, BUT not on Notif if exists on notif users already
        }
        const updateNameTypes = ['content'];
        disableNameFields && updateNameTypes.push('disable');

        getCurrErrors = updateNameKeys(
          field,
          localFormUpdates[props.formName],
          emailExistsAlready,
          updateNameTypes,
          getCurrErrors
        );
      } else {
        //Clear out name fields if just changed email from existing to non-existing
        field.includes('email') &&
          enteredExistingEmail.includes(field) &&
          (getCurrErrors = updateNameKeys(
            field,
            localFormUpdates[props.formName],
            {},
            ['content', 'enable'],
            getCurrErrors
          ));
        setEnteredExistingEmail(
          enteredExistingEmail.filter((f) => f !== field)
        );

        //Check for Required errors
        let isError = false;

        if (curr.parent) {
          //Is a grouped set of Required fields (i.e. checkbox or radio group)
          if (!curr['checked'] && !curr['allowEmpty']) {
            const somethingChecked = checkParentRequiredChecked(
              curr.parent,
              localFormUpdates[props.formName]
            );

            if (!somethingChecked) {
              !getCurrErrors.includes(curr.parent) &&
                getCurrErrors.push(curr.parent);
              isError = true;
            } else {
              getCurrErrors = getCurrErrors.filter((f) => f !== curr.parent);
            }
          } else {
            getCurrErrors = getCurrErrors.filter((f) => f !== curr.parent);
          }
        } else {
          //Standard Required field
          isError = checkRequiredContent(update, curr);

          const useAsField = curr.parent ? curr.parent : field;

          if (isError) {
            !getCurrErrors.includes(field) && getCurrErrors.push(field);
          } else if (fieldsWithError.includes(useAsField)) {
            getCurrErrors = getCurrErrors.filter((f) => f !== useAsField);
          }
        }
        curr['error'] = isError;
        const useLabel = GetLabels(curr['label'], spPageText);
        const getLabelForError = (label: string) =>
          label.length > 30 ? `${label.slice(0, 30)}...` : label;

        curr['errorMsg'] = isError
          ? ` ${getLabelForError(useLabel)} ${t(
            'sellerProfile.dashboard.isRequired'
          )}`
          : '';


        if (curr['validate'] !== undefined && !isError) {
          const doValidation = validateInput(curr, t);

          isError = doValidation.error;

          if (isError) {
            if (field === 'iata_number' && !anyIataRequired && update.trim() === '') {
              isError = false;
              curr['error'] = false;
              curr['errorMsg'] = '';
            } else if (field === 'iata_number' && !anyIataRequired && update.trim() !== '') {
              curr['error'] = isError;
              curr['errorMsg'] = doValidation.msg;
            } else {
              curr['error'] = isError;
              curr['errorMsg'] = doValidation.msg;

              if (!getCurrErrors.includes(field)) {
                getCurrErrors.push(field);
              }
            }
          }
        }

      }
      setFieldsWithError([...getCurrErrors]);

      if (
        ['addNotificationRecip', 'editNotifications', 'editAPIcreds'].includes(
          props.formName
        )
      ) {
        localFormUpdates[props.formName][parentField].options[field] = curr;
        dispatch(setFormUpdates(localFormUpdates));
      } else if (['editMySettings'].includes(props.formName)) {
        if (field === 'preferred_language_type') {
          localFormUpdates[props.formName].userPreferences.options[field] =
            curr;
        } else if (parentField === 'preferences') {
          localFormUpdates[props.formName].userPreferences.options[
            parentField
          ].options[field] = curr;
        } else {
          localFormUpdates[props.formName][parentField].options[field] = curr;
        }
        dispatch(setFormUpdates(localFormUpdates));
      } else if ('editCompanyProfile' === props.formName) {
        if (['compDetails'].includes(parentField)) {
          localFormUpdates[props.formName].coInfo.options.compDetails.options[
            field
          ] = curr;
        } else if (
          ['bizContactDetails', 'adminContact', ''].includes(parentField)
        ) {
          localFormUpdates[props.formName].techOpAdminContacts.options[
            parentField
          ].options[field] = curr;
        } else if (
          ['bizModelInfo', 'impDetailsSub', 'sellerPOSinfo'].includes(
            parentField
          )
        ) {
          localFormUpdates[props.formName].impDetailsGroup.options[
            parentField
          ].options[field] = curr;
        }
        dispatch(setFormUpdates(localFormUpdates));
      } else if (['addUser', 'editUserProfile'].includes(props.formName)) {
        localFormUpdates[props.formName][field] = curr;
        dispatch(setFormUpdates(localFormUpdates));
      } else if ('questionnaire' === props.formName) {
        if (curr.type === 'radioOption') {
          dispatch(
            setFormUpdates({
              ...localFormUpdates,
              [props.formName]: {
                ...localFormUpdates[props.formName],
                options: {
                  ...localFormUpdates[props.formName].options,
                  [`option${curr?.id}`]: curr
                }
              }
            })
          );
        } else if (field === 'QUES008') {
          dispatch(
            setFormUpdates({
              ...localFormUpdates,
              [props.formName]: {
                ...localFormUpdates[props.formName],
                [field]: curr
              }
            })
          );
        } else {
          dispatch(
            setFormUpdates({
              ...localFormUpdates,
              [props.formName]: {
                ...localFormUpdates[props.formName],
                [parentField]: {
                  ...localFormUpdates[props.formName][parentField],
                  options: {
                    ...localFormUpdates[props.formName][parentField].options,
                    [field]: curr
                  }
                }
              }
            })
          );
        }
      }

      dispatch(
        setDisabledBttn({
          ...disabledBttn,
          [props.formName]: getCurrErrors.length > 0
        })
      );
    } catch (error) {
      console.log(error);
    }
  };

  const handleCalChange = (val, calProps) => {
    if (val && val instanceof Date && calProps?.content) {
      //compare old/new to prevent firing unintentionally enabling submit button
      const oldDate = format(new Date(calProps.content), 'PP');
      const newDate = format(new Date(val), 'PP');
      if (oldDate !== newDate) {
        dispatch(
          setFormUpdates({
            ...formUpdates,
            [props.formName]: {
              ...formUpdates[props.formName],
              impDetailsGroup: {
                ...formUpdates[props.formName].impDetailsGroup,
                options: {
                  ...formUpdates[props.formName].impDetailsGroup.options,
                  [calProps.parentField]: {
                    ...formUpdates[props.formName].impDetailsGroup.options[
                    calProps.parentField
                    ],
                    options: {
                      ...formUpdates[props.formName].impDetailsGroup.options[
                        calProps.parentField
                      ].options,
                      [calProps.field]: {
                        ...formUpdates[props.formName].impDetailsGroup.options[
                          calProps.parentField
                        ].options[calProps.field],
                        content: [newDate]
                      }
                    }
                  }
                }
              }
            }
          })
        );
        dispatch(
          setDisabledBttn({
            ...disabledBttn,
            [props.formName]: fieldsWithError.length > 0
          })
        );
      }
    }
  };

  useEffect(() => {
    if (props.formName !== 'editCompanyProfile') return;
    const bizModelInfo =
      formUpdates?.editCompanyProfile?.impDetailsGroup?.options?.bizModelInfo;
    const iataNumber =
      bizModelInfo?.options?.iata_number?.content || '';
    const otherIataField = bizModelInfo?.options?.other_iata;
   
    // Determine if checkbox should be shown
    let showOtherIata = false;
    let iataNumStr = Array.isArray(iataNumber) ? iataNumber[0] || '' : iataNumber;
    if (anyIataRequired || (typeof iataNumStr === 'string' && /^\d{8}$/.test(iataNumStr))) {
      showOtherIata = true;
    }
    // Only try to reset if the field exists
    if (!showOtherIata && otherIataField) {
      // Get initial value from formData or fallback to 0
      const initialOtherIata =
        Array.isArray(props.formData?.other_iata)
          ? props.formData.other_iata[0]
          : 0;
      if (
        otherIataField.content !== initialOtherIata ||
        otherIataField.checked !== initialOtherIata
      ) {
        const localFormUpdates = JSON.parse(JSON.stringify(formUpdates));
        localFormUpdates.editCompanyProfile.impDetailsGroup.options.bizModelInfo.options.other_iata.content = initialOtherIata;
        localFormUpdates.editCompanyProfile.impDetailsGroup.options.bizModelInfo.options.other_iata.checked = initialOtherIata;
        localFormUpdates.editCompanyProfile.impDetailsGroup.options.bizModelInfo.options.other_iata.error = false;
        localFormUpdates.editCompanyProfile.impDetailsGroup.options.bizModelInfo.options.other_iata.errorMsg = '';
        dispatch(setFormUpdates(localFormUpdates));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    anyIataRequired,
    formUpdates?.editCompanyProfile?.impDetailsGroup?.options?.bizModelInfo?.options?.iata_number?.content
  ]);
   

  //******** PAGE LAYOUT functions
  const getLabel = (curr) => {
    //get label and if required, add *
    const required =
      curr['required'] && curr['required'] === 'true' ? ' *' : '';

    return `${GetLabels(curr['label'], spPageText)}${required}`;
  };
  const checkSpecialInstructions = (field, type) => {
    //for fields with a note next to them...
    const hideNote =
      (field?.hasOwnProperty('showNote') && field.showNote === false) || false;

    if (field?.hasOwnProperty('notes') && type === 'span' && !hideNote) {
      return (
        <div className="groupSpecInst">
          {GetLabels(field['notes'], spPageText)}
        </div>
      );
    } else if (
      field?.hasOwnProperty('clickableNotes') &&
      type === 'none' &&
      !hideNote
    ) {
      return (
        <span
          onClick={() => props.handleClickableNote(field) || null}
          className="fieldNote clickableNote"
          dangerouslySetInnerHTML={{
            __html: GetLabels(props.clickableNoteContent[field.id], spPageText)
          }}
        ></span>
      );
    } else if (field?.hasOwnProperty('notes') && type === 'h4' && !hideNote) {
      return <h4>{GetLabels(field['notes'], spPageText)}</h4>;
    } else if (field?.hasOwnProperty('notes') && type === 'none' && !hideNote) {
      return (
        <span
          className="fieldNote"
          dangerouslySetInnerHTML={{
            __html: GetLabels(field['notes'], spPageText)
          }}
        ></span>
      );
    }
  };
  const checkDisplayFieldText = (curr) => {
    if (curr.fieldText) {
      return {
        '&::after': {
          content: `"${spPageText[curr.fieldText]}"`,
          position: 'absolute',
          bottom: '.5em',
          right: 0,
          fontSize: '13px'
        }
      };
    }
  };
  let x = 0;

  const createField = (_curr, field, parentField, addLabeledBy = '') => {
    x++;
    const colStyle = props.cols === 'single' ? 'singleCol' : 'doubleCol';

    const curr = JSON.parse(JSON.stringify(_curr));

    if (curr.conditionalDisplay === 'iataRequired') {
      // Check if iata_number is 8 digits
      let iataNumber =
        formUpdates?.editCompanyProfile?.impDetailsGroup?.options?.bizModelInfo?.options?.iata_number?.content || '';
      if (Array.isArray(iataNumber)) {
        iataNumber = iataNumber[0] || '';
      }
      const isEightDigits = typeof iataNumber === 'string' && /^\d{8}$/.test(iataNumber);
      if (!anyIataRequired && !isEightDigits) {
        return null;
      }
    }

    switch (curr['type']) {
      case 'autocomplete':
        return (
          <FormControl
            fullWidth
            key={`${props.formName}${curr['label']}-${x}`}
            className={`spFormField ${colStyle}`}
          >
            <Autocomplete
              freeSolo
              id="combo-box-demo"
              options={emailsList}
              onChange={(e) =>
                handleChange(e, curr, field, parentField, 'autocomplete')
              }
              renderInput={(params) => (
                <TextField
                  className={`formTextField ${props.compName}`}
                  label={getLabel(curr)}
                  key={`${props.formName}${curr['label']}-${x}-${x}`}
                  name={curr['label']}
                  variant="standard"
                  autoComplete="off"
                  error={curr['error'] === true}
                  value={curr['content'] || ''}
                  onChange={(e) =>
                    handleChange(e, curr, field, parentField, 'autocomplete')
                  }
                  helperText={curr['error'] === true && curr['errorMsg']}
                  {...params}
                  disabled={
                    curr[`disabled${props.formName}`] === 'true' ||
                    curr.disabled ||
                    curr.mandatory ||
                    disableForm ||
                    false
                  }
                />
              )}
            />
          </FormControl>
        );
      case 'text':
        curr['content'] = curr['content'] === 'null' ? '' : curr['content']; //hide null from db in form
        if (field === 'iata_number') {
          curr['required'] = anyIataRequired ? 'true' : 'false';
        }
        return (
          <FormControl
            fullWidth
            key={`${props.formName}${curr['label']}-${x}`}
            className={`spFormField ${colStyle}`}
          >
            <TextField
              className={`formTextField ${props.compName} ${curr.fieldText ? 'fieldText' : ''
                }`}
              label={getLabel(curr)}
              key={`${props.formName}${curr['label']}-${x}-${x}`}
              name={curr['label']}
              variant="standard"
              id={`${props.formName}${curr['label']}-${x}`}
              value={curr['content'] || ''}
              onChange={(e) => handleChange(e, curr, field, parentField)}
              error={curr['error'] === true}
              helperText={curr['error'] === true && curr['errorMsg']}
              disabled={
                curr[`disabled${props.formName}`] === 'true' ||
                curr.disabled ||
                curr.mandatory ||
                disableForm ||
                false
              }
              //required={anyIataRequired}
              sx={checkDisplayFieldText(curr) || {}}
            />
            {curr.example && curr.example !== 'null' && (
              <div className={`formTextField ${props.compName} span`}>
                <span>{GetLabels(curr.example, spPageText)}</span>
              </div>
            )}
          </FormControl>
        );
      case 'select':
        return (
          <FormControl
            fullWidth
            key={`${props.formName}${curr['label']}-${x}`}
            className={`spFormField ${colStyle} selectList`}
          >
            <InputLabel id={`${props.formName}-inPutlabel-${x}`}>
              {getLabel(curr)}
            </InputLabel>
            <Select
              labelId={`${props.formName}-inPutlabel-${x}`}
              id={`${props.formName}${curr['label']}-${curr['content']}`}
              variant="standard"
              label={getLabel(curr)}
              name={curr['label']}
              multiple={curr['multiple'] || false}
              value={
                curr['multiple'] ? curr['content'] || [] : curr['content'] || ''
              }
              onChange={(e) => handleChange(e, curr, field, parentField)}
              open={
                showHideSelect[0].value === curr['label']
                  ? showHideSelect[0].key
                  : false
              }
              onOpen={() => handleShowHideSelect(curr['label'])}
              onClose={() => handleShowHideSelect(curr['label'])}
              MenuProps={{
                disableScrollLock: true
              }}
            >
              {curr['options'] && //replacing the curr['options'] with options to sort "All" to the top
                curr['options'].map((option, i) => {
                  const display = curr['translateValue']
                    ? GetLabels(option, spPageText)
                    : option;
                  return (
                    <MenuItem
                      value={option.replace('spPageText.', '')}
                      key={`${props.formName}${option.replaceAll(
                        ' ',
                        ''
                      )}-${i}`}
                    >
                      {display}
                    </MenuItem>
                  );
                })}
            </Select>
            {curr['label'] === 'spPageText.additionalAccess' && (
              <Typography fontSize={'.9rem'} color={'#737373'}>
                <strong>Note:</strong>{' '}
                <i> {GetLabels(curr['footerMsg'], spPageText)}</i>
              </Typography>
            )}
          </FormControl>
        );

      case 'checkbox':
        let checkboxContent = curr['content'];

        if (field === 'other_iata' && Array.isArray(checkboxContent)) {
          checkboxContent = checkboxContent[0];
        }

        const isChecked = curr['checked'] !== undefined
          ? curr['checked']
          : (checkboxContent === 'true' || checkboxContent === 1 || checkboxContent === true);

        const content = checkSpecialInstructions(curr, 'none');
        return (
          <div
            key={`${props.formName}${curr['label']}-${x}`}
            className="spCheckbox"
          >
            <FormControlLabel
              control={
                <Checkbox
                  name={curr['name']}
                  value={checkboxContent || ''}
                  checked={isChecked}
                  className={`spFormField`}
                  sx={{ display: 'inline-block' }}
                  onClick={(e) => handleChange(e, curr, field, parentField)}
                  disabled={curr['disabled'] || disableForm || false}
                />
              }
              label={getLabel(curr)}
            />
            {content}
          </div>
        );
      case 'radioOption':
        return (
          <FormControlLabel
            key={`${props.formName}${curr['label']}-${x}`}
            value={curr['name']}
            sx={{ display: 'grid' }}
            control={<Radio />}
            label={getLabel(curr)}
            onChange={(e) => handleChange(e, curr, field, parentField)}
          />
        );

      case 'calendar':
        return (
          <AppDatePicker
            key={`${props.formName}${curr['label']}-${x}`}
            label={getLabel(curr)}
            id={`${props.formName}dates-${x}`}
            keyName="dates"
            value={curr['content'] || ''}
            handleChange={handleCalChange}
            props={{ ...curr, parentField, field }}
          />
        );
      case 'autoComplete':
        return (
          <FormControl
            fullWidth
            key={`${props.formName}${curr['label']}-${x}`}
            className={`spFormField ${colStyle}`}
          >
            <Autocomplete
              multiple
              sx={{
                '& .MuiAutocomplete-endAdornment': {
                  top: '95%',
                  mt: '-14px'
                },
                '& .MuiAutocomplete-clearIndicator': {
                  '&:hover, &:active': {
                    backgroundColor: 'unset'
                  },
                  color: '#000'
                },
                '& .MuiAutocomplete-popupIndicator': {
                  '&:hover, &:active': {
                    backgroundColor: 'unset'
                  }
                },
                '& .MuiTouchRipple-root': {
                  display: 'none'
                }
              }}
              popupIcon={<ArrowDropDown fontSize="large" htmlColor="#000" />}
              renderTags={(value, getTagProps) => {
                return value.map((option, index) => (
                  <Chip
                    variant="outlined"
                    label={option}
                    sx={{
                      height: '32px',
                      color: '#000'
                    }}
                    {...getTagProps({ index })}
                    deleteIcon={
                      <img
                        src={CloseIcon}
                        height={'12px'}
                        alt="closeicon"
                        style={{
                          padding: '0 3px'
                        }}
                      />
                    }
                  />
                ));
              }}
              PopperComponent={(props) => (
                <Popper
                  {...props}
                  id="autocomplete-popper"
                  popperOptions={{
                    modifiers: [
                      {
                        name: 'flip',
                        options: {
                          fallbackPlacements: []
                        }
                      }
                    ]
                  }}
                />
              )}
              id={field}
              inputValue={curr['inputText']}
              value={curr['content'] ? [...curr['content']] : undefined}
              onInputChange={(_e, newval, reason) => {
                if (reason === 'input') {
                  curr['setInputText'](newval);
                }
              }}
              options={curr['options']}
              // filterOptions={options => options.filter(option => option.toLowerCase().includes(textValue.toLowerCase()))}
              getOptionLabel={(option) => option}
              defaultValue={curr['content']}
              onOpen={() => handleShowHideSelect(curr['label'])}
              onClose={() => handleShowHideSelect(curr['label'])}
              onChange={(e, newValue) => {
                handleChange(
                  newValue,
                  curr,
                  field,
                  parentField,
                  'autoComplete'
                );
                curr['setInputText']('');
              }}
              renderInput={(params) => {
                return (
                  <TextField
                    {...params}
                    variant="standard"
                    label={getLabel(curr)}
                    name={curr['name']}
                    InputLabelProps={{
                      ...params.InputLabelProps,
                      style: {
                        left: 0
                      }
                    }}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <Box
                          sx={{
                            top: '100%',
                            color: '#000'
                          }}
                        >
                          {params.InputProps.endAdornment}
                        </Box>
                      )
                    }}
                  />
                );
              }}
            />
            {/* {(curr["tooltip"] && curr["content"]) === "" &&
                toolTip(curr)} */}
          </FormControl>
        );
    }
  };
  let closestGroupParent = '';
  const displayLowestLevelFields = (curr, field) => {
    if (
      curr['type'] === 'group' ||
      curr['type'] === 'subgroup' ||
      curr['parentArray'] === true
    ) {
      closestGroupParent = field;
      const groupFields = curr['options'];
      const getGroupField =
        groupFields &&
        Object.keys(groupFields).map((opField) => {
          return displayLowestLevelFields(groupFields[opField], opField);
        });
      if (curr['type'] === 'subgroup') {
        return (
          <div
            className="formSubgroup"
            key={`${props.formName}${curr['label']}`}
          >
            <h5>{GetLabels(curr['label'], spPageText)}</h5>
            {checkSpecialInstructions(curr, 'span')}
            {getGroupField}
          </div>
        );
      } else {
        return getGroupField;
      }
    } else if (curr['type'] === 'radio') {
      const getRadioField = Object.keys(curr['options']).map((opField) => {
        return createField(curr['options'][opField], field, closestGroupParent);
      });

      return (
        <FormControl>
          <legend
            id={`${props.formName}${curr['name']}-${x}`}
            className="formLabel"
            aria-label={getLabel(curr)}
          >
            {getLabel(curr)}
          </legend>
          <RadioGroup
            name={curr['name']}
            className={`spFormField ${props.compName}`}
            id={`${props.formName}-radio-buttons-group-${x}`}
            aria-labelledby={`${props.formName}${curr['name']}-${x}`}
          >
            {getRadioField}
          </RadioGroup>
        </FormControl>
      );
    } else {
      let addLabeledBy = '';
      if (curr['type'] === 'checkbox') {
        addLabeledBy = closestGroupParent;
      }
      return createField(curr, field, closestGroupParent, addLabeledBy);
    }
  };

  if (formUpdates[props.formName]?.['editCompanyProfile']) {
    formUpdates[props.formName]['editCompanyProfile']['options']['coInfo'][
      'inputText'
    ] = inputTextPos;
    formUpdates[props.formName]['editCompanyProfile']['options']['coInfo'][
      'setInputText'
    ] = setInputTextPos;

    // formUpdates[props.formName]['editCompanyProfile']['options']['techOpAdminContacts']['inputText'] = inputTextOPos;
    // formUpdates[props.formName]['editCompanyProfile']['options']['techOpAdminContacts']['setInputText'] = setInputTextOPos;
  }

  return !formLoading && formUpdates[props.formName] ? (
    <div
      ref={formRef}
      className={`spForm ${props.compName ? props.compName : ''}`}
      key={props.formName}
    >
      {Object.keys(formUpdates[props.formName]).map((field) => {
        const isHeadOrSubhead =
          formUpdates[props.formName][field]['label'] &&
          (formUpdates[props.formName][field]['type'] === 'group' ||
            formUpdates[props.formName][field]['type'] === 'subgroup');
        return (
          <div
            key={`${props.formName}${field}-t`}
            className={`${isHeadOrSubhead ? 'spFormGroup' : ''} ${props.compName ? props.compName : ''
              } sp-${formUpdates[props.formName][field]['type']}`}
            aria-label={getLabel(formUpdates[props.formName][field])}
          >
            {isHeadOrSubhead && (
              <h3>{getLabel(formUpdates[props.formName][field])}</h3>
            )}
            {isHeadOrSubhead &&
              checkSpecialInstructions(
                formUpdates[props.formName][field],
                'h4'
              )}
            {displayLowestLevelFields(
              formUpdates[props.formName][field],
              field
            )}
          </div>
        );
      })}
    </div>
  ) : (
    <Box sx={{ height: '50vh' }} ref={initialRef}></Box>
  );
}

export default SPForm;
